module.exports = __webpack_public_path__ + "static/media/like.de306dbd.svg";